import { render, staticRenderFns } from "./SummaryBand.vue?vue&type=template&id=8b7bf9a4&scoped=true"
import script from "./SummaryBand.vue?vue&type=script&lang=js"
export * from "./SummaryBand.vue?vue&type=script&lang=js"
import style0 from "./SummaryBand.vue?vue&type=style&index=0&id=8b7bf9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bf9a4",
  null
  
)

export default component.exports